<template>
  <div id="feedback-form">
    <img
      src="../assets/machinecore_logo_small_final@2x.png"
      srcset="
        ../assets/machinecore_logo_small_final@1x.png 1x,
        ../assets/machinecore_logo_small_final@2x.png 2x
      "
    /><br /><br />
    <h1>Submit Test Feedback</h1>
    <form>
      <div v-if="isError" class="error">Error with form<br /></div>
      <p>What do you want to tell us?</p>
      <textarea v-model="payload.feedback_text" required /><br />
      <div v-if="isFeedbackTextError" class="error">No Feedback</div>
      <br />
      <p>How does your feedback make you feel?</p>
      <div id="emotion" class="emoji">
        <input
          id="happy"
          v-model="payload.feedback_rating"
          class="input_hidden"
          type="radio"
          name="emotion"
          value="10"
        />
        <label
          :class="{ selected: 10 == selected }"
          for="happy"
          @click="setFeedbackRating(10)"
          ><img src="../assets/happy.png"
        /></label>
        <input
          id="neutral"
          v-model="payload.feedback_rating"
          class="input_hidden"
          type="radio"
          name="emotion"
          value="5"
        />
        <label
          :class="{ selected: 5 == selected }"
          for="neutral"
          @click="setFeedbackRating(5)"
          ><img src="../assets/neutral.png"
        /></label>
        <input
          id="sad"
          v-model="payload.feedback_rating"
          class="input_hidden"
          type="radio"
          name="emotion"
          value="1"
        />
        <label
          :class="{ selected: 1 == selected }"
          for="mad"
          @click="setFeedbackRating(1)"
          ><img src="../assets/mad.png"
        /></label>
      </div>
      <div v-if="isFeedbackRatingError" class="error">Not Selected</div>
      <br />
      <p>Would you recommend this site to a friend?</p>
      <input
        v-model="payload.referral_rating"
        type="radio"
        name="refer"
        value="10"
      />
      <label class="refer" for="referChoiceYes">Yes</label>&nbsp;&nbsp;
      <input
        v-model="payload.referral_rating"
        type="radio"
        name="refer"
        value="1"
      />
      <label class="refer" for="referChoiceNo">No</label><br />
      <div v-if="isFeedbackReferralError" class="error">Not Selected</div>
      <br /><br />
      Token:<br />
      <input
        v-model.trim="payload.token"
        class="token"
        type="text"
        placeholder="Token"
        required
      /><br />
      <div v-if="isTokenError" class="error">No Token</div>
      <button type="button" class="button button-300" @click="createFeedback">
        Send Feedback</button
      ><br />
      <div v-if="feedbackReceivedMessage" class="error form-300">
        Feedback Received
      </div>
      <br />
    </form>
  </div>
</template>

<script>
import api from "@/api/index";
const apiServiceFeedback = new api.APIServiceFeedback();

export default {
  data() {
    return {
      payload: {
        feedback_rating: "",
        referral_rating: "",
        feedback_text: "",
        token: " "
      },
      isError: false,
      isFeedbackTextError: false,
      isFeedbackRatingError: false,
      isFeedbackReferralError: false,
      isTokenError: false,
      selected: undefined,
      feedbackReceivedMessage: false
    };
  },
  created() {
    this.clearForm();
  },
  methods: {
    createFeedback: function(e) {
      this.isError = false;
      this.isFeedbackTextError = false;
      this.isFeedbackRatingError = false;
      this.isFeedbackReferralError = false;
      this.isTokenError = false;
      this.feedbackReceivedMessage = false;
      if (!this.payload.feedback_text) {
        this.isError = true;
        this.isFeedbackTextError = true;
      }
      if (!this.payload.token) {
        this.isError = true;
        this.isTokenError = true;
      }
      if (!this.payload.feedback_rating) {
        this.isError = true;
        this.isFeedbackRatingError = true;
      }
      if (!this.payload.referral_rating) {
        this.isError = true;
        this.isFeedbackReferralError = true;
      }
      if (!this.isError) {
        this.feedbackReceivedMessage = false;
        apiServiceFeedback
          .createFeedback(this.payload)
          .then(data => {})
          .catch(e => {
            this.isError = true;
          });
        this.clearForm();
        this.feedbackReceivedMessage = true;
        this.payload.feedback_text = "";
        this.payload.feedback_rating = "";
        this.payload.referral_rating = "";
      }
    },
    setFeedbackRating: function(rating) {
      this.selected = rating;
      this.payload.feedback_rating = rating;
    },
    clearForm: function() {
      this.feedbackReceivedMessage = false;
      this.payload.feedback_text = "";
      this.payload.feedback_rating = "";
      this.payload.referral_rating = "";
      this.isError = false;
      this.isFeedbackTextError = false;
      this.isFeedbackRatingError = false;
      this.isFeedbackReferralError = false;
      this.isTokenError = false;
      this.selected = undefined;
    }
  }
};
</script>
<style>
#feedback-form {
  margin: 0 auto;
  width: 90%;
}
#feedback-form h2 {
  font-size: 28px;
}
#feedback-form p {
  font-size: 16px;
  margin-bottom: 5px;
}
.emoji img {
  width: 35px;
}
.input_hidden {
  position: absolute;
  left: -9999px;
}
.selected {
  background-color: #90c64d;
  border-radius: 4px;
}
#emotion label {
  display: inline-block;
  cursor: pointer;
  margin-right: 20px;
  width: 35px;
  height: 35px;
}
#feedback-form label.refer {
  font-size: 18px;
  padding-left: 4px;
}
#feedback-form textarea {
  font-size: 1.2em;
  padding: 6px;
  width: 400px;
  height: 200px;
  border-radius: 6px;
}
#feedback-form input[type="radio"]:after {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  top: -1px;
  left: -1px;
  position: relative;
  background-color: #d1d3d1;
  content: "";
  display: inline-block;
  visibility: visible;
  border: 2px solid white;
}
#feedback-form input[type="radio"]:checked:after {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  top: -1px;
  left: -1px;
  position: relative;
  background-color: #90c64d;
  content: "";
  display: inline-block;
  visibility: visible;
  border: 2px solid white;
}
input[type="text"].token {
  font-size: 12px;
  width: 300px;
}
@media (max-width: 480px) {
  #feedback-form textarea {
    width: 300px;
    height: 200px;
    border-radius: 6px;
  }
}
</style>
